import React, {useContext} from 'react';

// Include "none" modality for non-modal dialogs,
// but don't expose it publicly.
// TODO: Flesh out non-modal Dialog use-cases
type Unsafe_Modality = 'modal' | 'blocking' | 'none' | undefined;

export type DialogContextType = {
  closeDialog: () => void;
  closeDialogWithoutConfirm: () => void;
  registerLabelId: (id: string) => void;
  registerDescriptionId: (id: string) => void;
  modality: Unsafe_Modality;
};

export const DialogContext = React.createContext<DialogContextType | null>(
  null,
);

export function useDialogContext(): DialogContextType {
  const context = useContext(DialogContext);
  if (context === null) {
    throw new Error(
      '`useDialogContext()` was called from outside of a DialogContext.Provider.',
    );
  }
  return context;
}
